import React from "react";
import UsersList from "./components/UsersList";
import UsersSearch from "./components/UsersSearch";

export default () => {
  
  return (
    <div className="app-drawer">
        <div className="bg-white app-drawer-content">
            <UsersSearch />
            <div style={{height: 'calc(100vh - 276px)'}}>
                <UsersList />
            </div>
        </div>
    </div>
  );
};
